import React from 'react';
import { useQuery } from '@apollo/client';
import { Container, Typography, CircularProgress, Box, Paper } from '@mui/material';
import { GET_MY_SHOPIFY_PRODUCTS, GET_COMPANY_CONNECTIONS } from '../../../graphql/queries';
import ListingsTable from './ListingTable';
import InventoryIcon from '@mui/icons-material/Inventory';
import EmptyState from '../../../Components/EmptyState/EmptyState';

const MyListings: React.FC = () => {
  const emptyImage = require('../../../assets/images/Empty1.png');

  const { data: connectionsData, loading: connectionsLoading } = useQuery(
    GET_COMPANY_CONNECTIONS
  );
  const hasConnections = Boolean(connectionsData?.companyConnections?.length);

  const { loading, error, data } = useQuery(GET_MY_SHOPIFY_PRODUCTS, {
    skip: !hasConnections,
  });

  if (connectionsLoading || (hasConnections && loading)) {
    return (
      <Container maxWidth="lg">
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
          <CircularProgress data-testid="loading-spinner" />
        </Box>
      </Container>
    );
  }

  if (!hasConnections) {
    return (
      <Container maxWidth="lg">
        <Box
          my={4}
          sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
        >
          <Typography variant="h4" gutterBottom>
            My Listings
          </Typography>
        </Box>
        <EmptyState
          image={emptyImage}
          text="Connect your Shopify store to view your product listings. Install the ShareStock app from your Shopify admin to get started."
          actionButtons={<></>}
        />
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="lg">
        <Box
          my={4}
          sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
        >
          <Typography variant="h4" gutterBottom>
            My Listings
          </Typography>
        </Box>
        <Paper sx={{ p: 3, textAlign: 'center' }}>
          <Typography color="error">Error: {error.message}</Typography>
        </Paper>
      </Container>
    );
  }

  const listings = data?.myShopifyProducts || [];

  return (
    <Container maxWidth="lg">
      <Box
        my={4}
        sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
      >
        <Typography variant="h4" gutterBottom>
          My Listings
        </Typography>
      </Box>
      {listings.length === 0 ? (
        <Paper sx={{ p: 6, textAlign: 'center' }}>
          <InventoryIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
          <Typography variant="h6" color="text.secondary" gutterBottom>
            No products found
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Connect your Shopify store and add products to see them here.
          </Typography>
        </Paper>
      ) : (
        <ListingsTable listings={listings} />
      )}
    </Container>
  );
};

export default MyListings;
